module.exports = __webpack_public_path__ + "media/images/flags/64/Benin-a43a0fab17dadb285a5027e75e34e012.png";